import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { updateFotoLicencia } from "../../../redux/actions";
import ErrorModal from "../../../components/modals/errorModal";
import SuccessModal from "../../../components/modals/successModal";
import Button from "../../../components/button";

function UpToUpdateFotoLicencia({ imagen, preview, handleBack, id, onLicenciaActualizada }) {
  const dispatch = useDispatch();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const [loading, setLoading] = useState(false);
  const openErrorModal = (message) => setErrorModal({ show: true, message });
  const closeErrorModal = () => setErrorModal({ show: false, message: "" });

  const handleConfirmar = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const formData = new FormData();

      formData.append("foto", imagen);
      formData.append("id", id);

      const response = await dispatch(updateFotoLicencia(formData));

      if (response) {
        setShowSuccessModal(true);
      } else {
        openErrorModal("Hubo un error al subir la foto.");
      }
    } catch (error) {
      console.error("Error al subir la foto:", error);
      openErrorModal("Hubo un error al intentar subir la foto.");
    } finally {
      setLoading(false);
    }
  };

  const closeSuccessModal = () => {
    setShowSuccessModal(false);
    if (typeof onLicenciaActualizada === "function") {
      onLicenciaActualizada();
    }
  };

  return (
    <div>
      <div className="flex min-h-screen flex-col  items-center bg-black/90 inset-0 z-50 fixed">
        {preview ? (
          <div className="flex flex-col  items-center">
            <img
              src={preview}
              alt="Imagen"
              className="w-[20rem] my-[3rem] rounded-lg overflow-hidden"
            />

            <div className="justify-center items-center flex">
              <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                <Button
                  variant="secondary"
                  size="lg"
                  fullWidth
                  onClick={handleBack}
                >
                  Cancelar
                </Button>
                <Button
                  size="lg"
                  fullWidth
                  onClick={() => handleConfirmar()}
                  loading={loading}
                >
                  Confirmar foto
                </Button>
              </div>
            </div>
          </div>
        ) : (
          <div>Hubo un problema al cargar la foto</div>
        )}
      </div>
      {showSuccessModal && (
        <SuccessModal
          closeSuccessModal={closeSuccessModal}
          message="Foto subida con éxito."
        />
      )}
      {errorModal.show && (
        <ErrorModal
          closeErrorModal={closeErrorModal}
          message={errorModal.message}
        />
      )}
    </div>
  );
}
export default UpToUpdateFotoLicencia;
